// usePermissions.js
export const usePermissions = (moduleKey) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  // لو المستخدم SUPER_ADMIN وعنده all: true، نفتح له كل حاجة فوراً
  if (user.role?.name === 'SUPER_ADMIN' || user.role?.permissions?.all) {
    return { canRead: true, canCreate: true, canUpdate: true, canDelete: true, isAdmin: true };
  }

  // سحب صلاحيات الموديول المحدد (مثلاً workorders)
  const modulePerms = user.role?.permissions?.[moduleKey] || {};

  return {
    canRead: !!modulePerms.read,
    canCreate: !!modulePerms.create,
    canUpdate: !!modulePerms.update,
    canDelete: !!modulePerms.delete,
    isAdmin: false
  };
};